










import { Component, Prop, Vue } from 'vue-property-decorator';
import Card from './Card.vue';

@Component({
    components: {
        Card
    }
})
export default class FeatureCard extends Vue {
    @Prop({default: '', type: String}) name: string;
    @Prop({default: '', type: String}) description: string;
    @Prop({default: '', type: String}) image: string;
}
